import { render, staticRenderFns } from "./ClinicianReportButtonCopy.vue?vue&type=template&id=36cd6059&"
import script from "./ClinicianReportButtonCopy.vue?vue&type=script&lang=js&"
export * from "./ClinicianReportButtonCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports